import AlertMessageDialog from "@/components/custom-ui/result-dialog";
import type { PaperlessEobMessage } from "@/types/paperless-eob";

type PaperlessEobResultDialogProps = {
  message: PaperlessEobMessage;
  onClose: () => void;
  testId?: string;
};

const PaperlessEobResultDialog = ({
  message,
  onClose,
  testId,
}: PaperlessEobResultDialogProps) => {
  return (
    <AlertMessageDialog message={message} onClose={onClose} testId={testId} />
  );
};

export default PaperlessEobResultDialog;
